/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown>, relative: NonNullable<unknown> }} Chat_Tool_Confirm_Expires_AtInputs */



/**
* | output |
* | --- |
* | "Waiting for your approval — expires at {time} ({relative})" |
*
* @param {Chat_Tool_Confirm_Expires_AtInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_confirm_expires_at = /** @type {((inputs: Chat_Tool_Confirm_Expires_AtInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Confirm_Expires_AtInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Wartet auf Ihre Bestätigung – läuft um ${i?.time} ab (${i?.relative})`)
	return /** @type {LocalizedString} */ (`Waiting for your approval — expires at ${i?.time} (${i?.relative})`)
});